module.exports = __webpack_public_path__ + "static/img/BU01KB-1.cd8f252.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BU01KB-1.jpg
// module id = 8p9J
// module chunks = 1